import {useState} from "react";
import {useAppDispatch} from "app/hooks";
import {Localizer} from "infrastructure/localization/localizer";
import useEffectAsync from "infrastructure/effect";
import {AccountService} from "services/account/accountService";
import {HttpClientService} from "../../services/httpClient/httpClientService";
import {UserProfile} from "../../core/components/userProfile/userProfile";
import {Loading} from "../../core/components/loading/loading";
import {SetTitleBar} from "../../core/layout/titleBar/titleBarApi";
import {LogbogUserInfoApi} from "../../services/api/logbogUser/logbogUserInfoApi";
import {UserProfileModel} from "../../core/components/userProfile/userProfileModel";
import {Tab, Tabs} from "../../core/components/Tabs/Tabs";
import {SentMails} from "../uddannelseslaege/components/sentMails";

const userService = new AccountService();
const userApi = new LogbogUserInfoApi(new HttpClientService(), userService);

export function UserProfilePage() {
    const dispatch = useAppDispatch();
    const [isLoading, setIsLoading] = useState(true);
    const [user, setUser] = useState(new UserProfileModel());

    SetTitleBar(Localizer.profilepage_myProfile(),
        [{text: Localizer.global_user(), url: ""}]);

    const tabs: Tab[] = [
        {title: Localizer.global_profile(), id: "profile", content: <UserProfile user={user}/>, defaultActive: true},
        {
            title: Localizer.profilepage_SentEmails(),
            id: "sentEmails",
            content: (<SentMails userId={user.userId}/>),
            defaultActive: false
        }
    ];

    useEffectAsync(async () => {
        const result = await userApi.getUserInfoWithRoles();
        setUser(result);
        setIsLoading(false);
    }, [dispatch])

    return (
        <Loading isLoading={isLoading} text={Localizer.profilepage_getProfil()}>
            <Tabs tabs={tabs}/>
        </Loading>
    );
}
